export const textIdentifier = {
    "change-password": {
      "arabic": "تغيير كلمة المرور",
      "eng": "Change Password",
      "hindi": "पासवर्ड बदलें",
      "bahasa": "Ganti kata sandi",
      "ja": "パスワードを変更する",
      "viet": "Đổi mật khẩu",
      "chinese": "更改密碼"
    },
    "logout": {
      "arabic": "تسجيل خروج",
      "eng": "Logout",
      "hindi": "लॉग आउट",
      "bahasa": "Keluar",
      "ja": "ログアウト",
      "viet": "Đăng xuất",
      "chinese": "登出"
    },
    "hi": {
        "arabic": "أهلاً",
        "eng": "Hi",
        "hindi": "नमस्ते",
        "bahasa": "Hai",
        "ja": "やあ",
        "viet": "CHÀO xuất",
        "chinese": "你好"
      },
    "home": {
      "arabic": "بيت",
      "eng": "Home",
      "hindi": "घर",
      "bahasa": "Rumah",
      "ja": "家",
      "viet": "Nhà",
      "chinese": "家"
    },
    "schools-classes": {
      "arabic": "المدارس والفصول",
      "eng": "Schools & Classes",
      "hindi": "स्कूल और कक्षाएं",
      "bahasa": "Sekolah &amp; Kelas",
      "ja": "学校とクラス",
      "viet": "Trường & Lớp học",
      "chinese": "學校與班級"
    },
    "view-classes": {
      "arabic": "مشاهدة الفئات",
      "eng": "View Classes",
      "hindi": "कक्षाएं देखें",
      "bahasa": "Lihat Kelas",
      "ja": "クラスを見る",
      "viet": "Xem lớp học",
      "chinese": "查看課程"
    },
    "students-list": {
      "arabic": "قائمة الطلاب",
      "eng": "Student's list",
      "hindi": "छात्र सूची",
      "bahasa": "Daftar siswa",
      "ja": "生徒一覧",
      "viet": "danh sách sinh viên",
      "chinese": "學生名單"
    },
    "yet-to-start": {
      "arabic": "ولكن للبدء",
      "eng": "Yet to Start",
      "hindi": "अभी शुरू होना बाकी है",
      "bahasa": "Belum Mulai",
      "ja": "まだ開始していません",
      "viet": "chưa bắt đầu",
      "chinese": "尚未開始"
    },
    "ongoing": {
      "arabic": "جاري التنفيذ",
      "eng": "Ongoing",
      "hindi": "चल रही है",
      "bahasa": "Sedang berlangsung",
      "ja": "進行中",
      "viet": "đang diễn ra",
      "chinese": "進行中"
    },
    "class-selected": {
      "arabic": "تم اختيار فئة",
      "eng": "Class selected",
      "hindi": "कक्षा चयनित",
      "bahasa": "Kelas dipilih",
      "ja": "クラスが選択されました",
      "viet": "Lớp đã chọn",
      "chinese": "所選班級"
    },
    "ended": {
      "arabic": "انتهى",
      "eng": "Ended",
      "hindi": "समाप्त",
      "bahasa": "Berakhir",
      "ja": "終了しました",
      "viet": "Đã kết thúc",
      "chinese": "結束"
    },
    "status": {
      "arabic": "حالة",
      "eng": "Status",
      "hindi": "दर्जा",
      "bahasa": "Status",
      "ja": "スターテス",
      "viet": "Tình trạng",
      "chinese": "地位"
    },
    "duration": {
      "arabic": "مدة",
      "eng": "Duration",
      "hindi": "अवधि",
      "bahasa": "Durasi",
      "ja": "間隔",
      "viet": "Khoảng thời gian",
      "chinese": "期間"
    },
    "hour(s)": {
      "arabic": "ساعات",
      "eng": " hour(s)",
      "hindi": " घंटे",
      "bahasa": "jam",
      "ja": "時間",
      "viet": "giờ",
      "chinese": "小時"
    },
    "minute(s)": {
      "arabic": "دقائق",
      "eng": " minute(s)",
      "hindi": " मिनट",
      "bahasa": "menit",
      "ja": "分",
      "viet": "phút",
      "chinese": "分鐘"
    },
    "from": {
      "arabic": "من",
      "eng": "From",
      "hindi": "से",
      "bahasa": "Dari",
      "ja": "から",
      "viet": "Từ",
      "chinese": "從"
    },
    "view-syllabus": {
      "arabic": "عرض المنهج الدراسي",
      "eng": "View Syllabus",
      "hindi": "पाठ्यक्रम देखें",
      "bahasa": "Lihat Silabus",
      "ja": "シラバスを見る",
      "viet": "Xem giáo trình",
      "chinese": "查看教學大綱"
    },
    "view-status": {
      "arabic": "عرض الحالة",
      "eng": "View Status",
      "hindi": "स्थिति देखें",
      "bahasa": "Lihat Status",
      "ja": "ステータスを見る",
      "viet": "Trạng thái xem",
      "chinese": "查看狀態"
    },
    "no-competitions-found": {
      "arabic": "لم يتم العثور على مسابقات",
      "eng": "No Competitions Found",
      "hindi": "कोई प्रतियोगिता नहीं मिली",
      "bahasa": "Tidak Ada Kompetisi Ditemukan",
      "ja": "大会が見つかりません",
      "viet": "Không tìm thấy cuộc thi nào",
      "chinese": "沒有找到比賽"
    },
    "view-overall-report": {
      "arabic": "عرض التقرير العام",
      "eng": "View Overall Report",
      "hindi": "समग्र रिपोर्ट देखें",
      "bahasa": "Lihat Laporan Keseluruhan",
      "ja": "全体レポートを見る",
      "viet": "Xem báo cáo tổng thể",
      "chinese": "查看整體報告"
    },
    "report-shall-be-available-only-after-the-competition-has-ended": {
      "arabic": "يجب أن يكون التقرير متاحًا فقط بعد انتهاء المسابقة",
      "eng": "Report shall be available only after the competition has ended",
      "hindi": "प्रतियोगिता समाप्त होने के बाद ही रिपोर्ट उपलब्ध होगी",
      "bahasa": "Laporan akan tersedia hanya setelah kompetisi berakhir",
      "ja": "レポートは、競技会が終了した後にのみ利用できるものとします",
      "viet": "Báo cáo sẽ chỉ có sẵn sau khi cuộc thi kết thúc",
      "chinese": "報告僅在比賽結束後可用"
    },
    "no-reports-found": {
      "arabic": "لم يتم العثور على تقارير",
      "eng": "no-reports-found",
      "hindi": "कोई रिपोर्ट नहीं मिली",
      "bahasa": "tidak ada laporan yang ditemukan",
      "ja": "レポートが見つかりません",
      "viet": "không tìm thấy báo cáo",
      "chinese": "沒有發現報告"
    },
    "algerbraic-expressions": {
      "arabic": "تعابير جزائرية",
      "eng": "Algerbraic Expressions",
      "hindi": "बीजगणितीय भाव",
      "bahasa": "Ekspresi Aljabar",
      "ja": "代数式",
      "viet": "biểu thức đại số",
      "chinese": "代數表達式"
    },
    "algerbraic-terms": {
      "arabic": "شروط ألجربرايك",
      "eng": "Algerbraic Terms",
      "hindi": "बीजगणित की शर्तें",
      "bahasa": "Istilah Aljabar",
      "ja": "代数項",
      "viet": "thuật ngữ đại số",
      "chinese": "代數術語"
    },
    "fractions": {
      "arabic": "الكسور",
      "eng": "Fractions",
      "hindi": "भिन्न",
      "bahasa": "Pecahan",
      "ja": "分数",
      "viet": "phân số",
      "chinese": "分數"
    },
    "please-enter-valid-password": {
      "arabic": "الرجاء إدخال كلمة مرور صالحة",
      "eng": "Please enter valid password",
      "hindi": "कृपया वैध पासवर्ड दर्ज करें",
      "bahasa": "Masukkan kata sandi yang valid",
      "ja": "有効なパスワードを入力してください",
      "viet": "Vui lòng nhập mật khẩu hợp lệ",
      "chinese": "請輸入有效密碼"
    },
    "minimum-length-of-password-should-be-6": {
      "arabic": "يجب أن يكون الحد الأدنى لطول كلمة المرور 6",
      "eng": "Minimum length of password should be 6",
      "hindi": "पासवर्ड की न्यूनतम लंबाई 6 होनी चाहिए",
      "bahasa": "Panjang kata sandi minimum harus 6",
      "ja": "パスワードの最小長は 6 にする必要があります",
      "viet": "Độ dài tối thiểu của mật khẩu phải là 6",
      "chinese": "密碼的最小長度應為 6"
    },
    "passwords-didn't-match": {
      "arabic": "كلمات المرور غير متطابقة",
      "eng": "Passwords didn't match",
      "hindi": "पासवर्ड मेल नहीं खाते",
      "bahasa": "Kata sandi tidak cocok",
      "ja": "パスワードが一致しませんでした",
      "viet": "Mật khẩu không khớp",
      "chinese": "密碼不匹配"
    },
    "enter-old-password": {
      "arabic": "أدخل كلمة المرور القديمة",
      "eng": "Enter Old Password",
      "hindi": "पुराना पासवर्ड डालें",
      "bahasa": "Masukkan Kata Sandi Lama",
      "ja": "古いパスワードを入力してください",
      "viet": "Nhập mật khẩu cũ",
      "chinese": "輸入舊密碼"
    },
    "min-6-characters": {
      "arabic": "دقيقة. 6 أحرف",
      "eng": "Min. 6 Characters",
      "hindi": "मिन। 6 वर्ण",
      "bahasa": "Min. 6 Karakter",
      "ja": "最小。 6文字",
      "viet": "tối thiểu 6 ký tự",
      "chinese": "分鐘6個字符"
    },
    "enter-new-password": {
      "arabic": "أدخل كلمة مرور جديدة",
      "eng": "Enter New Password",
      "hindi": "नया पासवर्ड दर्ज करें",
      "bahasa": "Masukan kata sandi baru",
      "ja": "新しいパスワードを入力してください",
      "viet": "Nhập mật khẩu mới",
      "chinese": "輸入新密碼"
    },
    "re-enter-new-password": {
      "arabic": "أعد إدخال كلمة المرور الجديدة",
      "eng": "Re-Enter New Password",
      "hindi": "नया पासवर्ड पुनः दर्ज करें",
      "bahasa": "Masukkan Ulang Kata Sandi Baru",
      "ja": "新しいパスワードを再入力してください",
      "viet": "Nhập lại mật khẩu mới",
      "chinese": "重新輸入新的密碼"
    },
    "confirm": {
      "arabic": "يلغي",
      "eng": "Confirm",
      "hindi": "पुष्टि करें",
      "bahasa": "Membatalkan",
      "ja": "キャンセル",
      "viet": "Hủy bỏ",
      "chinese": "取消"
    },
    "email-resent": {
      "arabic": "البريد الإلكتروني مستاء",
      "eng": "Email Resent",
      "hindi": "ईमेल फिर से भेजा गया",
      "bahasa": "Email Dikirim Ulang",
      "ja": "メールの再送信",
      "viet": "email phẫn nộ",
      "chinese": "電子郵件重新發送"
    },
    "email-sent": {
      "arabic": "أرسل البريد الإلكتروني",
      "eng": "Email Sent",
      "hindi": "ईमेल भेजा",
      "bahasa": "Email terkirim",
      "ja": "メール送信済み",
      "viet": "Email đã gửi",
      "chinese": "郵件已發送"
    },
    "enter-your-email-to-get-password-reset-link": {
      "arabic": "أدخل بريدك الإلكتروني للحصول على رابط إعادة تعيين كلمة المرور",
      "eng": "Enter your email to get password reset link",
      "hindi": "पासवर्ड रीसेट लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें",
      "bahasa": "Masukkan email Anda untuk mendapatkan link reset password",
      "ja": "メールアドレスを入力してパスワードリセットリンクを取得してください",
      "viet": "Nhập email của bạn để nhận liên kết đặt lại mật khẩu",
      "chinese": "輸入您的電子郵件以獲取密碼重置鏈接"
    },
    "email": {
      "arabic": "بريد إلكتروني",
      "eng": "Email",
      "hindi": "ईमेल",
      "bahasa": "Surel",
      "ja": "Eメール",
      "viet": "E-mail",
      "chinese": "電子郵件"
    },
    "name@domian-com": {
      "arabic": "name@domian.com",
      "eng": "name@domian.com",
      "hindi": "नाम@domian.com",
      "bahasa": "nama@domian.com",
      "ja": "name@domian.com",
      "viet": "tên@domian.com",
      "chinese": "姓名@domian.com"
    },
    "Didn’t-receive-the-link": {
      "arabic": "لم أتلق الرابط",
      "eng": "Didn’t receive the link",
      "hindi": "लिंक नहीं मिला",
      "bahasa": "Tidak menerima tautan",
      "ja": "リンクが届かない",
      "viet": "Không nhận được liên kết",
      "chinese": "沒有收到鏈接"
    },
    "resend": {
      "arabic": "إعادة إرسال",
      "eng": "Resend",
      "hindi": "पुन: भेजे",
      "bahasa": "Kirim ulang",
      "ja": "再送",
      "viet": "gửi lại",
      "chinese": "重發"
    },
    "reset-password": {
      "arabic": "إعادة تعيين كلمة المرور",
      "eng": "Reset Password",
      "hindi": "पासवर्ड रीसेट",
      "bahasa": "Atur Ulang Kata Sandi",
      "ja": "パスワードを再設定する",
      "viet": "Đặt lại mật khẩu",
      "chinese": "重設密碼"
    },
    "go-back-to-login": {
      "arabic": "العودة لتسجيل الدخول",
      "eng": "Go back to login",
      "hindi": "लॉगिन पर वापस जाएं",
      "bahasa": "Kembali ke login",
      "ja": "ログインに戻る",
      "viet": "Quay lại đăng nhập",
      "chinese": "返回登錄"
    },
    "invalid-password-please-enter-a-valid-password": {
      "arabic": "كلمة المرور غير صحيحة , الرجاء إدخال كلمة مرور صالحة",
      "eng": "Invalid password, please enter a valid password",
      "hindi": "अमान्य पासवर्ड, कृपया एक मान्य पासवर्ड दर्ज करें",
      "bahasa": "Kata sandi salah, harap masukkan kata sandi yang valid",
      "ja": "無効なパスワードです。有効なパスワードを入力してください",
      "viet": "Mật khẩu không hợp lệ, vui lòng nhập mật khẩu hợp lệ",
      "chinese": "密碼無效,請輸入有效密碼"
    },
    "password-should-be-minimum-6-character-long": {
      "arabic": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      "eng": "Password should be minimum 6 character long",
      "hindi": "पासवर्ड न्यूनतम 6 वर्ण लंबा होना चाहिए",
      "bahasa": "Panjang kata sandi harus minimal 6 karakter",
      "ja": "パスワードは 6 文字以上にする必要があります",
      "viet": "Mật khẩu phải dài tối thiểu 6 ký tự",
      "chinese": "密碼長度至少應為 6 個字符"
    },
    "invalid-please-re-enter-password": {
      "arabic": "غير صالح! الرجاء إعادة إدخال كلمة المرور",
      "eng": "Invalid! please re-enter password",
      "hindi": "अमान्य! कृपया पासवर्ड पुनः दर्ज करें",
      "bahasa": "Tidak sah! silahkan masukkan ulang password",
      "ja": "無効！パスワードを再入力してください",
      "viet": "Không hợp lệ! vui lòng nhập lại mật khẩu",
      "chinese": "無效的！請重新輸入密碼"
    },
    "invalid-password-did't-match": {
      "arabic": "غير صالح! كلمة المرور غير متطابقة",
      "eng": "Invalid! Password didn't match",
      "hindi": "अमान्य! पासवर्ड मेल नहीं खाता",
      "bahasa": "Tidak sah! Kata sandi tidak cocok",
      "ja": "無効！パスワードが一致しませんでした",
      "viet": "Không hợp lệ! Mật khẩu không khớp",
      "chinese": "無效的！密碼不匹配"
    },
    "invalid-re-enter-password": {
      "arabic": "غير صالح! إعادة إدخال كلمة المرور",
      "eng": "Invalid! Re Enter Password",
      "hindi": "अमान्य! पासवर्ड फिर से दर्ज करें",
      "bahasa": "Tidak sah! Masukkan Kembali password",
      "ja": "無効！パスワード再入力",
      "viet": "Không hợp lệ! Nhập lại mật khẩu",
      "chinese": "無效的！重新輸入密碼"
    },
    "enter-password": {
      "arabic": "أدخل كلمة المرور",
      "eng": "Enter Password",
      "hindi": "पास वर्ड दर्ज करें",
      "bahasa": "Masukkan kata kunci",
      "ja": "パスワードを入力する",
      "viet": "Nhập mật khẩu",
      "chinese": "輸入密碼"
    },
    "password-reset-successfully": {
      "arabic": "إعادة تعيين كلمة المرور بنجاح",
      "eng": "Password reset successfully",
      "hindi": "पासवर्ड सफलतापूर्वक रीसेट किया गया",
      "bahasa": "Reset kata sandi berhasil",
      "ja": "パスワードが正常にリセットされました",
      "viet": "Đặt lại mật khẩu thành công",
      "chinese": "密碼重置成功"
    },
    "invalid-email-please-enter-a-valid-email": {
      "arabic": "بريد إلكتروني غير صحيح , الرجاء إدخال بريد إلكتروني صالح",
      "eng": "Invalid email, please enter a valid email",
      "hindi": "अमान्य ईमेल, कृपया एक मान्य ईमेल दर्ज करें",
      "bahasa": "Email tidak valid, harap masukkan email yang valid",
      "ja": "無効な電子メールです。有効な電子メールを入力してください",
      "viet": "Email không hợp lệ, vui lòng nhập email hợp lệ",
      "chinese": "電子郵件無效,請輸入有效的電子郵件"
    },
    "login": {
      "arabic": "تسجيل الدخول",
      "eng": "Login",
      "hindi": "लॉग इन करें",
      "bahasa": "Gabung",
      "ja": "ログイン",
      "viet": "Đăng nhập",
      "chinese": "登錄"
    },
    "login-with-your-data-to-proceed": {
      "arabic": "تسجيل الدخول مع البيانات الخاصة بك للمتابعة",
      "eng": "Login with your data to proceed",
      "hindi": "आगे बढ़ने के लिए अपने डेटा के साथ लॉगिन करें",
      "bahasa": "Login dengan data Anda untuk melanjutkan",
      "ja": "続行するには、データでログインしてください",
      "viet": "Đăng nhập bằng dữ liệu của bạn để tiếp tục",
      "chinese": "使用您的數據登錄以繼續"
    },
    "password": {
      "arabic": "كلمة المرور",
      "eng": "Password",
      "hindi": "पासवर्ड",
      "bahasa": "Kata sandi",
      "ja": "パスワード",
      "viet": "Mật khẩu",
      "chinese": "密碼"
    },
    "forgot-password": {
      "arabic": "هل نسيت كلمة السر",
      "eng": "Forgot Password",
      "hindi": "पासवर्ड भूल गए हैं",
      "bahasa": "Tidak ingat kata sandi",
      "ja": "パスワードをお忘れですか",
      "viet": "Quên mật khẩu",
      "chinese": "忘記密碼"
    },
    "are-you-sure-want-to-logout": {
      "arabic": "هل أنت متأكد من أنك تريد تسجيل الخروج",
      "eng": "Are you sure want to logout",
      "hindi": "आगे बढ़ने के लिए अपने डेटा के साथ लॉगिन करें",
      "bahasa": "Anda yakin ingin logout",
      "ja": "ログアウトしてもよろしいですか",
      "viet": "Bạn có chắc chắn muốn đăng xuất",
      "chinese": "您確定要註銷嗎"
    },
    "error-occured": {
      "arabic": "حدث خطأ",
      "eng": "Error occured",
      "hindi": "त्रुटि हुई",
      "bahasa": "Terjadi kesalahan",
      "ja": "エラーがおきました",
      "viet": "Có lỗi",
      "chinese": "發生了錯誤"
    },
    "please-enter-class-name": {
      "arabic": "الرجاء إدخال اسم الفصل",
      "eng": "Please enter class name",
      "hindi": "कृपया कक्षा का नाम दर्ज करें",
      "bahasa": "Silakan masukkan nama kelas",
      "ja": "クラス名を入力してください",
      "viet": "Vui lòng nhập tên lớp",
      "chinese": "請輸入班級名稱"
    },
    "please-enter-class-code-extension": {
      "arabic": "الرجاء إدخال امتداد رمز الفصل الدراسي",
      "eng": "Please enter class code extension",
      "hindi": "कृपया क्लास कोड एक्सटेंशन दर्ज करें",
      "bahasa": "Masukkan ekstensi kode kelas",
      "ja": "クラスコード拡張子を入力してください",
      "viet": "Vui lòng nhập phần mở rộng mã lớp",
      "chinese": "請輸入班級代碼擴展"
    },
    "No": {
      "arabic": "لا",
      "eng": "No",
      "hindi": "संख्या",
      "bahasa": "TIDAK",
      "ja": "いいえ",
      "viet": "Không",
      "chinese": "不"
    },
    "admin-options": {
      "arabic": "خيارات المسؤول",
      "eng": "Admin Options",
      "hindi": "व्यवस्थापक विकल्प",
      "bahasa": "Opsi Admin",
      "ja": "管理オプション",
      "viet": "Tùy chọn quản trị",
      "chinese": "管理選項"
    },
    "add-a-class": {
      "arabic": "أضف فصل دراسي",
      "eng": "Add a Class",
      "hindi": "एक वर्ग जोड़ें",
      "bahasa": "Tambahkan Kelas",
      "ja": "クラスを追加",
      "viet": "Thêm một lớp học",
      "chinese": "添加班級"
    },
    "view": {
      "arabic": "منظر",
      "eng": "View",
      "hindi": "देखना",
      "bahasa": "Melihat",
      "ja": "意見",
      "viet": "Khung nhìn",
      "chinese": "看法"
    },
    "total-classes": {
      "arabic": "مجموع الفئات",
      "eng": "Total Classes",
      "hindi": "कुल वर्ग",
      "bahasa": "Jumlah Kelas",
      "ja": "クラス総数",
      "viet": "Tổng số lớp học",
      "chinese": "總班級"
    },
    "enter-class-name": {
      "arabic": "أدخل اسم الفصل",
      "eng": "enter class name",
      "hindi": "कक्षा का नाम दर्ज करें",
      "bahasa": "masukkan nama kelas",
      "ja": "クラス名を入力",
      "viet": "nhập tên lớp",
      "chinese": "輸入班級名稱"
    },
    "enter-class-code-extension": {
      "arabic": "أدخل امتداد كود الفصل",
      "eng": "enter class code extension",
      "hindi": "क्लास कोड एक्सटेंशन दर्ज करें",
      "bahasa": "masukkan ekstensi kode kelas",
      "ja": "クラスコード拡張子を入力してください",
      "viet": "nhập phần mở rộng mã lớp",
      "chinese": "輸入類代碼擴展"
    },
    "code": {
      "arabic": "شفرة",
      "eng": "CODE",
      "hindi": "कोड",
      "bahasa": "KODE",
      "ja": "コード",
      "viet": "MÃ SỐ",
      "chinese": "代碼"
    },
    "competitions": {
      "arabic": "مسابقات",
      "eng": "Competitions",
      "hindi": "प्रतियोगिता",
      "bahasa": "Kompetisi",
      "ja": "大会",
      "viet": "cuộc thi",
      "chinese": "比賽"
    },
    "competition": {
      "arabic": "مسابقة",
      "eng": "Competition",
      "hindi": "प्रतियोगिता",
      "bahasa": "Kompetisi",
      "ja": "コンペ",
      "viet": "Cuộc thi",
      "chinese": "競賽"
    },
    "reports": {
      "arabic": "التقارير",
      "eng": "Reports",
      "hindi": "रिपोर्ट",
      "bahasa": "laporan",
      "ja": "レポート",
      "viet": "báo cáo",
      "chinese": "報告"
    },
    "rank": {
      "arabic": "رتبة",
      "eng": "Rank",
      "hindi": "पद",
      "bahasa": "Pangkat",
      "ja": "ランク",
      "viet": "Cấp",
      "chinese": "秩"
    },
    "students": {
      "arabic": "طلاب",
      "eng": "Students",
      "hindi": "छात्र",
      "bahasa": "Siswa",
      "ja": "学生",
      "viet": "Sinh viên",
      "chinese": "學生"
    },
    "overall-report": {
      "arabic": "التقرير العام",
      "eng": "Overall Report",
      "hindi": "समग्र रिपोर्ट",
      "bahasa": "Laporan Keseluruhan",
      "ja": "全体報告書",
      "viet": "Báo cáo tổng thể",
      "chinese": "整體報告"
    },
    "subtopic-wise-report": {
      "arabic": "تقرير الحكمة الفرعية",
      "eng": "Subtopic wise Report",
      "hindi": "सबटॉपिक वार रिपोर्ट",
      "bahasa": "Subtopik bijaksana Laporan",
      "ja": "サブトピックごとのレポート",
      "viet": "Chủ đề phụ báo cáo khôn ngoan",
      "chinese": "副主題報告"
    },
    "overall-proficiency": {
      "arabic": "الكفاءة العامة",
      "eng": "Overall proficiency",
      "hindi": "कुल मिलाकर निपुणता",
      "bahasa": "Kemahiran secara keseluruhan",
      "ja": "全体的な習熟度",
      "viet": "trình độ tổng thể",
      "chinese": "綜合能力"
    },
    "school-proficiency": {
      "arabic": "إتقان المدرسة",
      "eng": "School proficiency",
      "hindi": "स्कूल की प्रवीणता",
      "bahasa": "Keahlian sekolah",
      "ja": "学校の習熟度",
      "viet": "trình độ học",
      "chinese": "學業水平"
    },
    "overall-accuracy": {
      "arabic": "دقة الشاملة",
      "eng": "Overall accuracy",
      "hindi": "समग्र शुद्धता",
      "bahasa": "Akurasi keseluruhan",
      "ja": "総合精度",
      "viet": "độ chính xác tổng thể",
      "chinese": "整體精度"
    },
    "school-accuracy": {
      "arabic": "دقة المدرسة",
      "eng": "School accuracy",
      "hindi": "स्कूल सटीकता",
      "bahasa": "Akurasi sekolah",
      "ja": "学校の正確さ",
      "viet": "độ chính xác của trường",
      "chinese": "學校準確性"
    },
    "overall-marks": {
      "arabic": "علامات عامة",
      "eng": "Overall marks",
      "hindi": "कुल अंक",
      "bahasa": "Tanda keseluruhan",
      "ja": "総合点",
      "viet": "tổng điểm",
      "chinese": "總分"
    },
    "school-marks": {
      "arabic": "علامات مدرسية",
      "eng": "School marks",
      "hindi": "स्कूल में अंक",
      "bahasa": "Nilai sekolah",
      "ja": "学校のマーク",
      "viet": "điểm trường",
      "chinese": "學業成績"
    },
    "no-data-found": {
      "arabic": "لاتوجد بيانات",
      "eng": "No data found",
      "hindi": "डाटा प्राप्त नहीं हुआ",
      "bahasa": "Tidak ada data ditemukan",
      "ja": "何もデータが見つかりませんでした",
      "viet": "Không tìm thấy dữ liệu nào",
      "chinese": "沒有找到數據"
    },
    "topic-name": {
      "arabic": "اسم الموضوع",
      "eng": "Topic Name",
      "hindi": "विषय का नाम",
      "bahasa": "Nama Topik",
      "ja": "トピック名",
      "viet": "Tên chủ đề",
      "chinese": "主題名稱"
    },
    "total-questions": {
      "arabic": "مجموع الأسئلة",
      "eng": "Total Questions",
      "hindi": "कुल सवाल",
      "bahasa": "Jumlah Pertanyaan",
      "ja": "総質問数",
      "viet": "Tổng số câu hỏi",
      "chinese": "總問題"
    },
    "total-marks": {
      "arabic": "مجموع علامات",
      "eng": "Total Marks",
      "hindi": "कुल मार्क",
      "bahasa": "Nilai Total",
      "ja": "合計点",
      "viet": "Tổng số điểm",
      "chinese": "總分"
    },
    "proficiency": {
      "arabic": "الكفاءة",
      "eng": "Proficiency",
      "hindi": "प्रवीणता",
      "bahasa": "Kecakapan",
      "ja": "習熟度",
      "viet": "thành thạo",
      "chinese": "熟練程度"
    },
    "marks-obtained": {
      "arabic": "العلامات المتحصل عليها",
      "eng": "Marks Obtained",
      "hindi": "अंक प्राप्त की",
      "bahasa": "Tanda yang Didapat",
      "ja": "獲得点数",
      "viet": "Điểm đạt được",
      "chinese": "獲得的分數"
    },
    "accuracy": {
      "arabic": "دقة",
      "eng": "Accuracy",
      "hindi": "सटीकता",
      "bahasa": "Ketepatan",
      "ja": "正確さ",
      "viet": "sự chính xác",
      "chinese": "準確性"
    },
    "question-correct": {
      "arabic": "سؤال صحيح",
      "eng": "Question Correct",
      "hindi": "प्रश्न सही",
      "bahasa": "Pertanyaan Benar",
      "ja": "質問正解",
      "viet": "câu hỏi đúng",
      "chinese": "問題正確"
    },
    "question-attempted": {
      "arabic": "حاول السؤال",
      "eng": "Question Attempted",
      "hindi": "प्रश्न प्रयास किया गया",
      "bahasa": "Pertanyaan Dicoba",
      "ja": "試みられた質問",
      "viet": "Đã thử câu hỏi",
      "chinese": "問題嘗試"
    },
    "previous-page": {
      "arabic": "الصفحة السابقة",
      "eng": "Previous Page",
      "hindi": "पिछला पृष्ठ",
      "bahasa": "Halaman sebelumnya",
      "ja": "前のページ",
      "viet": "Trang trước",
      "chinese": "上一頁"
    },
    "next-page": {
      "arabic": "الصفحة التالية",
      "eng": "Next Page",
      "hindi": "अगला पृष्ठ",
      "bahasa": "Halaman selanjutnya",
      "ja": "次のページ",
      "viet": "Trang tiếp theo",
      "chinese": "下一頁"
    },
    "You're-not-assigned-to-any-class": {
      "arabic": "لم يتم تعيينك لأي فصل دراسي",
      "eng": "You're not assigned to any class",
      "hindi": "आपको किसी वर्ग के लिए निर्दिष्ट नहीं किया गया हैपद",
      "bahasa": "Anda tidak ditugaskan ke kelas mana pun",
      "ja": "どのクラスにも割り当てられていません",
      "viet": "Bạn không được chỉ định vào bất kỳ lớp nào",
      "chinese": "你沒有被分配到任何班級"
    },
    "name": {
      "arabic": "اسم",
      "eng": "Name",
      "hindi": "नाम",
      "bahasa": "Nama",
      "ja": "名前",
      "viet": "Tên",
      "chinese": "姓名"
    },
    "no-student-attempts": {
      "arabic": "لا توجد محاولات طلابية",
      "eng": "No Student Attempts",
      "hindi": "कोई छात्र प्रयास नहीं",
      "bahasa": "Tidak Ada Upaya Siswa",
      "ja": "学生の試みはありません",
      "viet": "Không có nỗ lực của học sinh",
      "chinese": "沒有學生嘗試"
    },
    "no-classes-found": {
      "arabic": "لم يتم العثور على فئات",
      "eng": "No Classes Found",
      "hindi": "कोई कक्षा नहीं मिली",
      "bahasa": "Tidak Ada Kelas Ditemukan",
      "ja": "クラスが見つかりません",
      "viet": "Không tìm thấy lớp nào",
      "chinese": "沒有找到類"
    },
    "You're-not-assigned-to-any-school": {
      "arabic": "لم يتم تعيينك في أي مدرسة",
      "eng": "You're not assigned to any school",
      "hindi": "आपको किसी स्कूल के लिए असाइन नहीं किया गया है",
      "bahasa": "Anda tidak ditugaskan ke sekolah mana pun",
      "ja": "あなたはどの学校にも配属されていません",
      "viet": "Bạn không được chỉ định vào bất kỳ trường nào",
      "chinese": "你沒有被分配到任何學校"
    },
    "school": {
      "arabic": "مدرسة",
      "eng": "School",
      "hindi": "स्कूल",
      "bahasa": "Sekolah",
      "ja": "学校",
      "viet": "ngôi trường",
      "chinese": "學校"
    },
    "school-percentile": {
      "arabic": "النسبة المئوية للمدرسة",
      "eng": "School Percentile",
      "hindi": "स्कूल पर्सेंटाइल",
      "bahasa": "Persentil Sekolah",
      "ja": "学校パーセンタイル",
      "viet": "Phần trăm trường học",
      "chinese": "學校百分位數"
    },
    "total-schools": {
      "arabic": "مجموع المدارس",
      "eng": "Total Schools",
      "hindi": "कुल विद्यालय",
      "bahasa": "Jumlah Sekolah",
      "ja": "合計学校",
      "viet": "Tổng số trường học",
      "chinese": "學校總數"
    },
    "search-existing-student": {
      "arabic": "ابحث عن الطالب الحالي",
      "eng": "Search existing student",
      "hindi": "मौजूदा छात्र खोजें",
      "bahasa": "Cari siswa yang ada",
      "ja": "既存の学生を検索",
      "viet": "Tìm kiếm sinh viên hiện có",
      "chinese": "搜索現有學生"
    },
    "search": {
      "arabic": "يبحث",
      "eng": "Search",
      "hindi": "खोज",
      "bahasa": "Mencari",
      "ja": "検索",
      "viet": "Tìm kiếm",
      "chinese": "搜索"
    },
    "search-result": {
      "arabic": "نتيجة البحث",
      "eng": "Search result",
      "hindi": "खोज का परिणाम",
      "bahasa": "Hasil pencarian",
      "ja": "検索結果",
      "viet": "Tìm kêt quả",
      "chinese": "搜索結果"
    },
    "add": {
      "arabic": "يضيف",
      "eng": "Add",
      "hindi": "जोड़ें",
      "bahasa": "Menambahkan",
      "ja": "追加",
      "viet": "Thêm vào",
      "chinese": "添加"
    },
    "student-cannot-be-added": {
      "arabic": "لا يمكن إضافة الطالب",
      "eng": "Student cannot be added",
      "hindi": "छात्र जोड़ा नहीं जा सकता",
      "bahasa": "Siswa tidak dapat ditambahkan",
      "ja": "学生を追加できません",
      "viet": "Không thể thêm sinh viên",
      "chinese": "無法添加學生"
    },
    "please-enter-first-name": {
      "arabic": "الرجاء إدخال الاسم الأول",
      "eng": "Please enter first name",
      "hindi": "कृपया पहला नाम दर्ज करें",
      "bahasa": "Masukkan nama depan",
      "ja": "名を入力してください",
      "viet": "Vui lòng nhập tên",
      "chinese": "請輸入名字"
    },
    "please-enter-last-name": {
      "arabic": "الرجاء إدخال الاسم الأخير",
      "eng": "Please enter last name",
      "hindi": "कृपया अंतिम नाम दर्ज करें",
      "bahasa": "Masukkan nama belakang",
      "ja": "姓を入力してください",
      "viet": "Vui lòng nhập họ",
      "chinese": "請輸入姓氏"
    },
    "please-enter-email": {
      "arabic": "الرجاء إدخال البريد الإلكتروني",
      "eng": "Please enter email",
      "hindi": "कृपया ईमेल दर्ज करें",
      "bahasa": "Silakan masukkan email",
      "ja": "メールアドレスを入力してください",
      "viet": "Vui lòng nhập email",
      "chinese": "請輸入郵箱"
    },
    "please-enter-password": {
      "arabic": "الرجاء إدخال كلمة المرور",
      "eng": "Please Enter Password",
      "hindi": "कृपया पास वर्ड दर्ज करें",
      "bahasa": "Silakan Masukkan Kata Sandi",
      "ja": "パスワードを入力してください",
      "viet": "Xin vui lòng nhập mật khẩu",
      "chinese": "請輸入密碼"
    },
    "please-enter-confirm-password": {
      "arabic": "الرجاء إدخال تأكيد كلمة المرور",
      "eng": "Please enter confirm password",
      "hindi": "छात्र जोड़ा नहीं जा सकता",
      "bahasa": "Silakan masukkan konfirmasi kata sandi",
      "ja": "確認用パスワードを入力してください",
      "viet": "Vui lòng nhập xác nhận mật khẩu",
      "chinese": "請輸入確認密碼"
    },
    "passwords-do-not-match": {
      "arabic": "كلمة المرور غير مطابقة",
      "eng": "Passwords do not match",
      "hindi": "सांकेतिक शब्द मेल नहीं खाते",
      "bahasa": "Sandi tidak cocok",
      "ja": "パスワードが一致していません",
      "viet": "Mật khẩu không phù hợp",
      "chinese": "密碼不匹配"
    },
    "first-name": {
      "arabic": "الاسم الأول",
      "eng": "First Name",
      "hindi": "पहला नाम",
      "bahasa": "Nama depan",
      "ja": "ファーストネーム",
      "viet": "Tên đầu tiên",
      "chinese": "名"
    },
    "last-name": {
      "arabic": "اسم العائلة",
      "eng": "Last Name",
      "hindi": "उपनाम",
      "bahasa": "Nama keluarga",
      "ja": "苗字",
      "viet": "Họ",
      "chinese": "姓"
    },
    "enter-student-first-name": {
      "arabic": "أدخل الاسم الأول للطالب",
      "eng": "Enter Student First Name",
      "hindi": "छात्र का पहला नाम दर्ज करें",
      "bahasa": "Masukkan Nama Depan Siswa",
      "ja": "生徒の名を入力してください",
      "viet": "Nhập Tên Học Sinh",
      "chinese": "輸入學生的名字"
    },
    "enter-student-last-name": {
      "arabic": "أدخل الاسم الأخير للطالب",
      "eng": "Enter Student Last Name",
      "hindi": "छात्र का अंतिम नाम दर्ज करें",
      "bahasa": "Masukkan Nama Belakang Siswa",
      "ja": "学生の姓を入力してください",
      "viet": "Nhập Họ của Học sinh",
      "chinese": "輸入學生姓氏"
    },
    "enter-student-email-id": {
      "arabic": "أدخل معرف البريد الإلكتروني للطالب",
      "eng": "Enter Student Email ID",
      "hindi": "छात्र ईमेल आईडी दर्ज करें",
      "bahasa": "Masukkan ID Email Siswa",
      "ja": "学生のメール ID を入力してください",
      "viet": "Nhập ID email sinh viên",
      "chinese": "輸入學生電子郵件 ID"
    },
    "email-id": {
      "arabic": "عنوان الايميل",
      "eng": "Email Id",
      "hindi": "ईमेल आईडी",
      "bahasa": "Nomor Email",
      "ja": "電子メールID",
      "viet": "ID email",
      "chinese": "電子郵件ID"
    },
    "confirm-password": {
      "arabic": "تأكيد كلمة المرور",
      "eng": "Confirm Password",
      "hindi": "पासवर्ड की पुष्टि कीजियेपद",
      "bahasa": "konfirmasi sandi",
      "ja": "パスワードを認証する",
      "viet": "Xác nhận mật khẩu",
      "chinese": "確認密碼"
    },
    "add-student": {
      "arabic": "أضف طالب",
      "eng": "Add Student",
      "hindi": "पासवर्ड की पुष्टि कीजिये",
      "bahasa": "Tambahkan Siswa",
      "ja": "生徒を追加",
      "viet": "Thêm sinh viên",
      "chinese": "添加學生"
    },
    "new-student": {
      "arabic": "طالب جديد",
      "eng": "New Student",
      "hindi": "नया विद्यार्थी",
      "bahasa": "Murid baru",
      "ja": "新入生",
      "viet": "Sinh viên mới",
      "chinese": "新生"
    },
    "existing-student": {
      "arabic": "الطالب الحالي",
      "eng": "Existing Student",
      "hindi": "मौजूदा छात्र",
      "bahasa": "Siswa yang Ada",
      "ja": "既存の学生",
      "viet": "Sinh viên hiện tại",
      "chinese": "現有學生"
    },
    "delete-student": {
      "arabic": "حذف الطالب",
      "eng": "Delete Student",
      "hindi": "छात्र हटाएं",
      "bahasa": "Hapus Siswa",
      "ja": "生徒を削除",
      "viet": "Xóa sinh viên",
      "chinese": "刪除學生"
    },
    "please-select-a-student": {
      "arabic": "الرجاء تحديد طالب",
      "eng": "Please select a student",
      "hindi": "कृपया एक छात्र का चयन करें",
      "bahasa": "Silakan pilih siswa",
      "ja": "生徒を選択してください",
      "viet": "Vui lòng chọn một học sinh",
      "chinese": "請選擇學生"
    },
    "cancel": {
      "arabic": "يلغي",
      "eng": "Cancel",
      "hindi": "रद्द करना",
      "bahasa": "Membatalkan",
      "ja": "キャンセル",
      "viet": "Hủy bỏ",
      "chinese": "取消"
    },
    "delete": {
      "arabic": "يمسح",
      "eng": "Delete",
      "hindi": "मिटाना",
      "bahasa": "Menghapus",
      "ja": "消去",
      "viet": "Xóa bỏ",
      "chinese": "刪除"
    },
    "are-you-sure-you-want-to-delete": {
      "arabic": "هل أنت متأكد أنك تريد حذف",
      "eng": "Are you sure you want to delete",
      "hindi": "क्या आप आश्वस्त है कि आपको डिलीट करना है",
      "bahasa": "Anda yakin ingin menghapus",
      "ja": "消去してもよろしいですか",
      "viet": "Bạn có chắc chắn muốn xóa",
      "chinese": "你確定你要刪除"
    },
    "progress-if-any-would-be-lost": {
      "arabic": "التقدم إذا كان سيضيع",
      "eng": "progress if any would be lost",
      "hindi": "प्रगति अगर कोई खो जाएगा",
      "bahasa": "kemajuan jika ada akan hilang",
      "ja": "失われるものがある場合は進行",
      "viet": "tiến bộ nếu có sẽ bị mất",
      "chinese": "任何進展都會丟失"
    },
    "yes-delete": {
      "arabic": "نعم , احذف",
      "eng": "Yes, Delete",
      "hindi": "हाँ, हटाओ",
      "bahasa": "Ya, Hapus",
      "ja": "はい、削除します",
      "viet": "Có, Xóa",
      "chinese": "是的,刪除"
    },
    "student-name": {
      "arabic": "أسم الطالب",
      "eng": "Student Name",
      "hindi": "पद",
      "bahasa": "Nama siswa",
      "ja": "学生の名前",
      "viet": "Tên học sinh",
      "chinese": "學生姓名"
    },
    "total-students": {
      "arabic": "مجموع الطلاب",
      "eng": "Total Students",
      "hindi": "कुल छात्र",
      "bahasa": "Jumlah Siswa",
      "ja": "総生徒数",
      "viet": "Tổng số học sinh",
      "chinese": "學生總數"
    },
    "not-done": {
      "arabic": "لم تفعل",
      "eng": "Not Done",
      "hindi": "नहीं हुआ",
      "bahasa": "Belum selesai",
      "ja": "まだ完成してない",
      "viet": "Không được thực hiện",
      "chinese": "尚未完成"
    },
    "finished": {
      "arabic": "انتهى",
      "eng": "Finished",
      "hindi": "खत्म",
      "bahasa": "Selesai",
      "ja": "終了した",
      "viet": "Hoàn thành",
      "chinese": "完成的"
    },
    "warm-up": {
      "arabic": "تسخين",
      "eng": "Warm Up",
      "hindi": "जोश में आना",
      "bahasa": "Pemanasan",
      "ja": "準備し始める",
      "viet": "Ấm lên",
      "chinese": "暖身"
    },
    "practise": {
      "arabic": "يمارس",
      "eng": "Practice",
      "hindi": "अभ्यास",
      "bahasa": "Praktik",
      "ja": "練習",
      "viet": "Luyện tập",
      "chinese": "實踐"
    },
    "view-test-design": {
      "arabic": "عرض تصميم الاختبار",
      "eng": "View Test Design",
      "hindi": "टेस्ट डिजाइन देखें",
      "bahasa": "Lihat Desain Tes",
      "ja": "テスト設計を表示",
      "viet": "Xem thiết kế thử nghiệm",
      "chinese": "查看測試設計"
    },
    "preview": {
      "arabic": "معاينة",
      "eng": "Preview",
      "hindi": "पूर्वावलोकन",
      "bahasa": "Pratinjau",
      "ja": "プレビュー",
      "viet": "Xem trước",
      "chinese": "預覽"
    },
    "question": {
      "arabic": "سؤال",
      "eng": "Question",
      "hindi": "सवाल",
      "bahasa": "Pertanyaan",
      "ja": "質問",
      "viet": "Câu hỏi",
      "chinese": "問題"
    },
    "you-are-not-authorized-to-access-this-panel": {
      "arabic": "أنت غير مصرح لك للوصول إلى هذه اللوحة",
      "eng": "You are not authorized to access this panel",
      "hindi": "आप इस पैनल को एक्सेस करने के लिए अधिकृत नहीं हैं",
      "bahasa": "Anda tidak diizinkan untuk mengakses panel ini",
      "ja": "このパネルにアクセスする権限がありません",
      "viet": "Bạn không được phép truy cập bảng điều khiển này",
      "chinese": "您無權訪問此面板"
    },
    "Oh-snap-you-got-an-error!": {
      "arabic": "أوه المفاجئة! لديك خطأ!",
      "eng": "Oh snap! You got an error!",
      "hindi": "ओह तस्वीर! आपको एक त्रुटि मिली!",
      "bahasa": "Oh jepret! Anda mendapat kesalahan!",
      "ja": "ああスナップ！エラーが発生しました。",
      "viet": "Ôi chao! Bạn đã có một lỗi!",
      "chinese": "快點！你有錯誤！"
    },
    "chip-success": {
      "arabic": "نجاح الرقاقة",
      "eng": "chip-success",
      "hindi": "चिप-सफलता",
      "bahasa": "chip-sukses",
      "ja": "チップ成功",
      "viet": "chip thành công",
      "chinese": "芯片成功"
    },
    "chip-warning": {
      "arabic": "رقاقة التحذير",
      "eng": "chip-warning",
      "hindi": "चिप-चेतावनी",
      "bahasa": "chip-warning",
      "ja": "チップ警告",
      "viet": "cảnh báo chip",
      "chinese": "切屑警告"
    },
    "chip-danger": {
      "arabic": "خطر الرقائق",
      "eng": "chip-danger",
      "hindi": "चिप-खतरा",
      "bahasa": "chip-bahaya",
      "ja": "チップ危険",
      "viet": "nguy hiểm chip",
      "chinese": "切屑危險"
    },
    "no": {
      "arabic": "لا",
      "eng": "No",
      "hindi": "नहीं",
      "bahasa": "TIDAK",
      "ja": "いいえ",
      "viet": "Không",
      "chinese": "不"
    },
    "schools": {
      "arabic": "المدارس",
      "eng": "Schools",
      "hindi": "स्कूल",
      "bahasa": "Sekolah",
      "ja": "学校",
      "viet": "trường học",
      "chinese": "學校"
    },
    "search-by-school-name": {
      "arabic": "البحث عن طريق اسم المدرسة",
      "eng": "Search by School Name",
      "hindi": "चिप-सफलता",
      "bahasa": "Cari berdasarkan Nama Sekolah",
      "ja": "学校名で検索",
      "viet": "chip thành công",
      "chinese": "按學校名稱搜索"
    },
    "to": {
      "arabic": "ل",
      "eng": "to",
      "hindi": "को",
      "bahasa": "ke",
      "ja": "に",
      "viet": "đến",
      "chinese": "到"
    },
    "search-by-name-or-email": {
      "arabic": "البحث بالاسم أو البريد الإلكتروني",
      "eng": "Search by name or email",
      "hindi": "नाम या ईमेल से खोजें",
      "bahasa": "Telusuri berdasarkan nama atau email",
      "ja": "名前またはメールで検索",
      "viet": "Tìm kiếm theo tên hoặc email",
      "chinese": "按姓名或電子郵件搜索"
    },
    "classes": {
      "arabic": "الطبقات",
      "eng": "Classes",
      "hindi": "कक्षाएं",
      "bahasa": "Kelas",
      "ja": "クラス",
      "viet": "các lớp học",
      "chinese": "班級"
    },
    "eg-class-name": {
      "arabic": "على سبيل المثال: اسم الفصل",
      "eng": "Eg: Class name",
      "hindi": "उदाहरण के लिए a3",
      "bahasa": "Contoh: Nama kelas",
      "ja": "例: クラス名",
      "viet": "Ví dụ: Tên lớp",
      "chinese": "例如：類名"
    },
    "eg-a3": {
      "arabic": "Eg: A3",
      "eng": "Eg: A3",
      "hindi": "ví dụ-a3",
      "bahasa": "Misalnya: A3",
      "ja": "例: A3",
      "viet": "ví dụ-a3",
      "chinese": "例如A3"
    },
    "fetching": {
      "arabic": "الجلب",
      "eng": "Fetching",
      "hindi": "प्राप्त कर रहा है",
      "bahasa": "Mengambil",
      "ja": "取得中",
      "viet": "Đang tìm nạp",
      "chinese": "抓取"
    },
    "enter-ID": {
      "arabic": "أدخل المعرف",
      "eng": "Enter ID",
      "hindi": "आईडी दर्ज करें",
      "bahasa": "Masukkan ID",
      "ja": "IDを入力",
      "viet": "Nhập ID",
      "chinese": "輸入ID"
    },
    "select-student": {
      "arabic": "حدد الطالب",
      "eng": "Select Student",
      "hindi": "छात्र का चयन करें",
      "bahasa": "Pilih Siswa",
      "ja": "生徒を選択",
      "viet": "Chọn sinh viên",
      "chinese": "選擇學生"
    },
    "yes": {
      "arabic": "نعم",
      "eng": "Yes",
      "hindi": "हाँ",
      "bahasa": "Ya",
      "ja": "はい",
      "viet": "Có",
      "chinese": "是的"
    },
    "enter-student-enter-ID": {
      "arabic": "أدخل معرف إدخال الطالب",
      "eng": "Enter Student Enter-ID",
      "hindi": "एंटर-स्टूडेंट-एंटर-आईडी",
      "bahasa": "Masukkan Student Enter-ID",
      "ja": "学生の入力 ID を入力してください",
      "viet": "nhập-sinh viên-nhập-ID",
      "chinese": "輸入學生輸入 ID"
    },
    "search-by-email-ID": {
      "arabic": "البحث عن طريق معرف البريد الإلكتروني",
      "eng": "Search by Email ID",
      "hindi": "ईमेल आईडी से खोजें",
      "bahasa": "Cari berdasarkan ID Email",
      "ja": "メールIDで検索",
      "viet": "Tìm kiếm theo ID Email",
      "chinese": "按電子郵件 ID 搜索"
    },
    "loading": {
      "arabic": "تحميل",
      "eng": "Loading",
      "hindi": "लोड हो रहा है",
      "bahasa": "Memuat",
      "ja": "読み込み中",
      "viet": "Đang tải",
      "chinese": "加載中"
    },
    "no-schools-found": {
      "arabic": "لم يتم العثور على مدارس",
      "eng": "No Schools Found",
      "hindi": "कोई स्कूल नहीं मिला",
      "bahasa": "Tidak Ditemukan Sekolah",
      "ja": "学校が見つかりません",
      "viet": "Không Tìm Thấy Trường Học",
      "chinese": "沒有找到學校"
    },
    "no-students-found": {
      "arabic": "لم يتم العثور على طلاب",
      "eng": "No Students Found",
      "hindi": "कोई विद्यार्थी नहीं मिला",
      "bahasa": "Tidak Ada Siswa yang Ditemukan",
      "ja": "生徒が見つかりません",
      "viet": "Không Tìm Thấy Trường Học",
      "chinese": "找不到學生"
    },
    "back": {
      "arabic": "خلف",
      "eng": "Back",
      "hindi": "पीछे",
      "bahasa": "Kembali",
      "ja": "戻る",
      "viet": "Trở lại",
      "chinese": "後退"
    },
    "not-attempted": {
      "arabic": "لم تحاول",
      "eng": "Not attempted",
      "hindi": "प्रयास नहीं किया",
      "bahasa": "Tidak dicoba",
      "ja": "未試行",
      "viet": "không cố gắng",
      "chinese": "沒有嘗試"
    },
    "average-question-count": {
      "arabic": "متوسط عدد الأسئلة",
      "eng": "Average Question Count",
      "hindi": "औसत प्रश्न संख्या",
      "bahasa": "Jumlah Pertanyaan Rata-Rata",
      "ja": "平均質問数",
      "viet": "Số lượng câu hỏi trung bình",
      "chinese": "平均問題數"
    },
    "question-count": {
      "arabic": "عدد الأسئلة",
      "eng": "Question Count",
      "hindi": "प्रश्न संख्या",
      "bahasa": "Jumlah Pertanyaan",
      "ja": "質問数",
      "viet": "hỏi trung bình",
      "chinese": "問題數"
    },
    "average-marks": {
      "arabic": "متوسط العلامات",
      "eng": "Average Marks",
      "hindi": "औसत अंक",
      "bahasa": "Tanda Rata-Rata",
      "ja": "平均点",
      "viet": "điểm trung bình",
      "chinese": "平均分"
    },
    "class-school-rank": {
      "arabic": "رتبة مدرسة الصف",
      "eng": "Class School Rank",
      "hindi": "कक्षा स्कूल रैंक",
      "bahasa": "Peringkat Sekolah Kelas",
      "ja": "クラス 学校ランク",
      "viet": "Hạng Trường Xếp Hạng",
      "chinese": "班級學校排名"
    },
    "class-school-percentile": {
      "arabic": "النسبة المئوية لمدرسة الفصل",
      "eng": "Class School Percentile",
      "hindi": "कक्षा स्कूल प्रतिशतक",
      "bahasa": "Persentil Sekolah Kelas",
      "ja": "クラス学校パーセンタイル",
      "viet": "Phân vị trường lớp",
      "chinese": "班級學校百分位數"
    },
    "class-overall-rank": {
      "arabic": "التصنيف العام للفئة",
      "eng": "Class Overall Rank",
      "hindi": "वर्ग समग्र रैंक",
      "bahasa": "Peringkat Keseluruhan Kelas",
      "ja": "クラス総合順位",
      "viet": "Xếp loại chung của lớp",
      "chinese": "班級綜合排名"
    },
    "class-overall-percentile": {
      "arabic": "النسبة المئوية الإجمالية للفئة",
      "eng": "Class Overall Percentile",
      "hindi": "कक्षा समग्र प्रतिशतक",
      "bahasa": "Persentil Keseluruhan Kelas",
      "ja": "クラス全体のパーセンタイル",
      "viet": "Phân vị tổng thể của lớp",
      "chinese": "班級總百分位數"
    },
    "class-rank": {
      "arabic": "الطبقة رتبة",
      "eng": "Class Rank",
      "hindi": "वर्ग रैंक",
      "bahasa": "Peringkat kelas",
      "ja": "階級",
      "viet": "Xếp hạng lớp",
      "chinese": "班級排名"
    },
    "class-percentile": {
      "arabic": "النسبة المئوية للفئة",
      "eng": "Class Percentile",
      "hindi": "कक्षा प्रतिशतक",
      "bahasa": "Persentil Kelas",
      "ja": "クラスパーセンタイル",
      "viet": "Phần trăm lớp",
      "chinese": "班級百分位數"
    },
    "school-rank": {
      "arabic": "رتبة المدرسة",
      "eng": "School Rank",
      "hindi": "स्कूल रैंक",
      "bahasa": "Peringkat Sekolah",
      "ja": "学校ランク",
      "viet": "Xếp hạng trường học",
      "chinese": "學校排名"
    },
    "competition-rank": {
      "arabic": "رتبة المنافسة",
      "eng": "Competition Rank",
      "hindi": "प्रतियोगिता रैंक",
      "bahasa": "Peringkat Kompetisi",
      "ja": "大会ランク",
      "viet": "Thứ hạng cạnh tranh",
      "chinese": "比賽名次"
    },
    "competition-percentile": {
      "arabic": "النسبة المئوية للمنافسة",
      "eng": "Competition Percentile",
      "hindi": "प्रतियोगिता प्रतिशतक",
      "bahasa": "Persentil Persaingan",
      "ja": "競合パーセンタイル",
      "viet": "Phần trăm cạnh tranh",
      "chinese": "競爭百分位數"
    },
    "participated": {
      "arabic": "شارك",
      "eng": "Participated",
      "hindi": "भाग लिया",
      "bahasa": "Berpartisipasi",
      "ja": "参加しました",
      "viet": "đã tham gia",
      "chinese": "參加過"
    },
    "marks": {
      "arabic": "ماركس",
      "eng": "Marks",
      "hindi": "निशान",
      "bahasa": "Tanda",
      "ja": "マーク",
      "viet": "điểm",
      "chinese": "分數"
    },
    "class-proficiency": {
      "arabic": "إتقان فئة",
      "eng": "class Proficiency",
      "hindi": "वर्ग-प्रवीणता",
      "bahasa": "Kemahiran kelas",
      "ja": "クラス習熟度",
      "viet": "thông thạo lớp",
      "chinese": "班級熟練程度"
    },
    "class-accuracy": {
      "arabic": "دقة الفصل",
      "eng": "Class Accuracy",
      "hindi": "कक्षा-सटीकता",
      "bahasa": "Akurasi Kelas",
      "ja": "クラス精度",
      "viet": "độ chính xác của lớp",
      "chinese": "類精度"
    },
    "class-marks": {
      "arabic": "علامات الفئة",
      "eng": "Class Marks",
      "hindi": "वर्ग-चिन्ह",
      "bahasa": "Tanda Kelas",
      "ja": "クラスマーク",
      "viet": "điểm lớp",
      "chinese": "等級標記"
    },
    "skills": {
        "arabic": "مهارات",
        "eng": "Skills",
        "hindi": "कौशल",
        "bahasa": "keterampilan",
        "ja": "スキル",
        "viet": "kỹ năng",
        "chinese": "技巧"
      },
    "highest-mark-possible" : {
      "arabic": "أعلى درجة ممكنة",
      "eng": "Highest Mark Possible",
      "hindi": "संभवतः सबसे उच्च अंक",
      "bahasa": "Nilai Tertinggi yang Mungkin",
      "ja": "可能な最高マーク",
      "viet": "Điểm Cao Nhất Có Thể",
      "chinese": "最高分可能性"
    },
    "action": {
      "arabic": "فعل",
      "eng": "Action",
      "hindi": "कार्रवाई",
      "bahasa": "Tindakan",
      "ja": "アクション",
      "viet": "Hoạt động",
      "chinese": "行动"
    },
    "reschedule":{
      "arabic": "إعادة جدولة",
      "eng": "Reschedule",
      "hindi": "पुनर्निर्धारित",
      "bahasa": "Menjadwalkan ulang",
      "ja": "スケジュールを変更する",
      "viet": "Lên lịch lại",
      "chinese": "重新安排"
    },
    "rescheduled":{
      "arabic": "إعادة جدولة",
      "eng": "Rescheduled",
      "hindi": "फिर से निर्धारित",
      "bahasa": "Dijadwalkan ulang",
      "ja": "再スケジュール",
      "viet": "Đã lên lịch lại",
      "chinese": "改期"
    },
    "change-deadline":{
      "arabic": "تغيير الموعد النهائي",
      "eng": "Change Deadline",
      "hindi": "समय सीमा बदलें",
      "bahasa": "Perubahan Batas Waktu",
      "ja": "変更期限",
      "viet": "Thay đổi thời hạn",
      "chinese": "更改截止日期"
    },
    "reset-now":{
      "arabic": "إعادة الضبط الآن",
      "eng": "Reset Now",
      "hindi": "अभी रीसेट करें",
      "bahasa": "Setel Ulang Sekarang",
      "ja": "今すぐリセット",
      "viet": "Đặt lại ngay",
      "chinese": "立即重置"
    },
    "action": {
      "arabic": "فعل",
      "eng": "Action",
      "hindi": "कार्रवाई",
      "bahasa": "Tindakan",
      "ja": "アクション",
      "viet": "Hoạt động",
      "chinese": "行动"
    },
    "start-date": {
      "arabic": "تاريخ البدء",
      "eng": "Start Date",
      "hindi": "आरंभ करने की तिथि",
      "bahasa": "Tanggal Mulai",
      "ja": "開始日",
      "viet": "Ngày bắt đầu",
      "chinese": "开始日期"
    },
    "end-date": {
      "arabic": "تاريخ الانتهاء",
      "eng": "End Date",
      "hindi": "अंतिम तिथि",
      "bahasa": "Tanggal Berakhir",
      "ja": "終了日",
      "viet": "Ngày kết thúc",
      "chinese": "结束日期"
    },
    "note": {
      "arabic": "ملحوظة",
      "eng": "Note",
      "hindi": "टिप्पणी",
      "bahasa": "Catatan",
      "ja": "注記",
      "viet": "Ghi chú",
      "chinese": "笔记"
    },
    "clicking-on-reschedule-will-reset-the-progress-of-this-student": {
      "arabic": `سيؤدي النقر على "إعادة الجدولة" إلى إعادة ضبط تقدم هذا الطالب`,
      "eng": `Clicking on "Reschedule" will reset the progress of this student`,
      "hindi": `"पुनर्निर्धारित" पर क्लिक करने से इस छात्र की प्रगति रीसेट हो जाएगी`,
      "bahasa": `Mengklik "Jadwalkan Ulang" akan mengatur ulang kemajuan siswa ini`,
      "ja": `「再スケジュール」をクリックすると、この生徒の進捗状況がリセットされます`,
      "viet": `Nhấp vào "Lên lịch" sẽ thiết lập lại tiến độ của học sinh này`,
      "chinese": `单击“重新安排”将重置该学生的进度`
    },
    "download-report": {
      "arabic": "تنزيل التقرير",
      "eng": "Download Report",
      "hindi": "रिपोर्ट डाउनलोड करें",
      "bahasa": "Unduh Laporan",
      "ja": "レポートのダウンロード",
      "viet": "Tải xuống báo cáo",
      "chinese": "下载报告"
    },
    "okay,-sure": {
      "arabic": "حسنًا، بالتأكيد",
      "eng": "Okay, Sure",
      "hindi": "ठीक है पक्का",
      "bahasa": "Oke, Tentu",
      "ja": "わかりました、もちろん",
      "viet": "Được rồi, chắc chắn rồi",
      "chinese": "好的，当然"
    },
    "the-report-cannot-be-downloaded-as-theres-no-registered-email-associated-with-your-account": {
      "arabic": "لا يمكن تنزيل التقرير لأنه لا يوجد بريد إلكتروني مسجل مرتبط بحسابك",
      "eng": "The report cannot be downloaded as there's no registered email associated with your account",
      "hindi": "रिपोर्ट डाउनलोड नहीं की जा सकती क्योंकि आपके खाते से कोई पंजीकृत ईमेल संबद्ध नहीं है",
      "bahasa": "Laporan tidak dapat diunduh karena tidak ada email terdaftar yang terkait dengan akun Anda",
      "ja": "アカウントに関連付けられた登録メールアドレスがないため、レポートをダウンロードできません",
      "viet": "Không thể tải xuống báo cáo vì không có email đăng ký nào được liên kết với tài khoản của bạn",
      "chinese": "由于没有与您的帐户关联的注册电子邮件，因此无法下载报告"
    },
    "the-reports-are-being-generated-now-and-will-be-sent-to": {
      "arabic": "يتم الآن إنشاء التقارير وسيتم إرسالها إلى",
      "eng": "The reports are being generated now and will be sent to",
      "hindi": "अभी रिपोर्ट तैयार की जा रही है और भेज दी जाएगी",
      "bahasa": "Laporan sedang dibuat sekarang dan akan dikirim ke",
      "ja": "レポートは現在生成されており、次の宛先に送信されます。",
      "viet": "Các báo cáo hiện đang được tạo và sẽ được gửi tới",
      "chinese": "报告正在生成中，并将发送至"
    },
    "soon": {
      "arabic": "قريباً",
      "eng": "soon",
      "hindi": "जल्द ही",
      "bahasa": "segera",
      "ja": "すぐ",
      "viet": "sớm",
      "chinese": "很快"
    },
    "error": {
      "arabic": "خطأ",
      "eng": "Error",
      "hindi": "गलती",
      "bahasa": "Kesalahan",
      "ja": "エラー",
      "viet": "Lỗi",
      "chinese": "错误"
    }
  }